export default __webpack_public_path__ + "static/media/tete55.3f089f83.png";